<template>
  <div
    class="as-tabs-icon"
    :class="{
      [`as-tabs-icon-${siteName}`]: siteName,
      'as-tabs-icon__border-top': isShowBorderTop,
      'as-tabs-icon__min': isMin,
      [modifyClass]: modifyClass,
    }"
  >
    <div
      v-for="(tab, key) in tabs"
      :key="key"
      class="as-tabs-icon__item"
      :class="{
        'as-active': activeTab === tab.key,
      }"
      @click="changeTag(tab.key)"
    >
      <component :is="tab.icon" />
      <span :class="isShowName ? 'as-show-name' : 'as-hide-name'">{{
        tab.title
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick, computed } from 'vue'
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface ITabsIconItem {
  key: string;
  title: string;
  icon: any;
}

interface IProps {
  tabs: ITabsIconItem[];
  activeTab: string;
  isShowName?: boolean;
  isShowBorderTop?: boolean;
  modifyClass?: string;
  isMin?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  activeTab: "",
  isShowName: false,
  isShowBorderTop: false,
  modifyClass: "",
  isMin: false
});

const siteName = computed(() => commonStore.getSiteName);
const activeElement = ref<HTMLElement | null>(null)
const emits = defineEmits(["change"])

const changeTag = (tag: string) => {
  emits("change", tag);
};

watch(() => props.activeTab, async () => {
  await nextTick()
  const el = document.querySelector('.as-match-detail .as-tabs-icon__item.as-active')
  if (!el) return

  activeElement.value = el as HTMLElement
  el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
}, { immediate: true })
</script>

<script lang="ts">
export default {};
</script>
